import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=8e5a95f2&"
import script from "./LayoutBase.vue?vue&type=script&lang=js&"
export * from "./LayoutBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports